import { useTextTranslation } from "../../utils/useTextTranslation";
import React, { useEffect, useRef, useState } from "react";
import TrashIcon from "../../assets/icons/svg/TrashIcon";
import defaultHorizontalPoster from "../../assets/images/default-vod-horizontal-poster.png";
import { getProgramPosterUrl } from "../../utils/getProgramPosterUrl";
import localizationStrings from "../../statics/localization";
import useOutsideClick from "../../utils/useOutsideClick";
import Notification from "../notification";
import { recordStateLabel } from "../../utils/recording";

const RecordItem = ({
  item,
  onSelect,
  title,
  deleteRecord,
  fromSearch,
  onHoverProgramItem,
  itemsToShow,
  trackId
}) => {
  const translateText = useTextTranslation();
  const [posterUrl, setPosterUrl] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const titleRef = useRef(null);
  const optionRef = useRef(null);
  const timeoutRef = useRef(null);
  const itemRef = useRef(null);

  useOutsideClick(optionRef, () => {
    setShowOptions(false);
  });

  useEffect(() => {
    if (item) {
      setPosterUrl(getProgramPosterUrl(item.posters) || defaultHorizontalPoster);
    }
  }, [item]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <div
      ref={itemRef}
      className="vod-item cinema-record-card"
      data-track-id={trackId}
      style={{
        position: "relative",
        width: fromSearch ? "20%" : itemsToShow ? `${100 / itemsToShow}%` : ""
      }}
      onClick={(e) => {
        if (!showNotification) onSelect(item);
      }}
      onMouseEnter={() => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        if (!onHoverProgramItem || !window.matchMedia("(hover: hover) and (min-width: 1000px)").matches) return;
        timeoutRef.current = setTimeout(() => {
          if (itemRef.current?.closest(".cinema-scroll-track")?.dataset.scrolling === "true") return;
          let pos = itemRef.current?.getClientRects();
          if (pos?.length) {
            pos = pos[0];
          }
          let _data = {
            position: pos,
            data: item
          };
          onHoverProgramItem(true, _data);
        }, 500);
      }}
      onMouseLeave={() => {
        clearTimeout(timeoutRef.current);
      }}
    >
      <div key={item?.programcode} className="carousel-item">
        <img
          className="carousel-poster"
          src={posterUrl}
          alt={translateText(title || item?.title || item?.prevuename || "")}
          onError={() => setPosterUrl(defaultHorizontalPoster)}
        />
      </div>

      <div
        className="record-title"
        ref={titleRef}
        style={{ display: !title ? "none" : "" }}
      >
        {translateText(title)}
        <small className="record-status">{recordStateLabel(item)}</small>
      </div>

      <div
        ref={optionRef}
        className="dot-options"
        style={{ display: fromSearch ? "none" : "" }}
      >
        <div className="dots-wrapper">
          <div className={`options-box ${showOptions ? "show" : ""}`}>
            <div className="tri-angle"></div>
            <div className="options">
              <div className="option" onClick={() => setShowNotification(true)}>
                <TrashIcon />
                <span>{localizationStrings.removeContent}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showNotification ? (
        <Notification
          text={localizationStrings.deleteRecordConfirmText}
          confirmText={localizationStrings.delete}
          notConfirmText={localizationStrings.cancel}
          onClickConfirm={() => {
            deleteRecord(item);
          }}
          onClickNotConfirm={() => setShowNotification(false)}
          switchButtons={true}
        />
      ) : null}
    </div>
  );
};

export default RecordItem;
